// extracted by mini-css-extract-plugin
module.exports = {"accountBlock":"invite-relation_accountBlock_3oWR2","textDecoration":"invite-relation_textDecoration_K1RWc","color":"invite-relation_color_GBw16"};